import { useAxios } from '@vueuse/integrations/useAxios'
import {backendClient} from "@/clients/backend.client";
import type {AxiosRequestConfig} from "axios";
import type {Link} from "@/types/link.type";

const defaultUseAxiosOptions = { immediate: true}

type CreateLink = Pick<Link, "url" | "title" | "subtitle" | "actions">;

export function useLinksApi() {
    const getLink = function(id: string, axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const config = { ...axiosRequestConfig, method: 'get'}
        return useAxios(`/link/${id}`, config, backendClient, useAxiosOptions)
    }

    const getLinkByGuid = function(guid: string, axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const config = { ...axiosRequestConfig, method: 'get'}
        return useAxios(`/link/guid/${guid}`, config, backendClient, useAxiosOptions)
    }

    const getUserLinks = function(axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const config = { ...axiosRequestConfig, method: 'get'}
        return useAxios('/link', config, backendClient, useAxiosOptions)
    }

    const createLink = function(link: CreateLink, axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const payload = { ...link };
        // Incase id is sent, remove it.
        delete (payload as any)["id"];
        const config = { ...axiosRequestConfig, data: payload, method: 'post'}
        return useAxios('/link', config, backendClient, useAxiosOptions)
    }

    const updateLink = function(link: CreateLink, axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const config = { ...axiosRequestConfig, data: link, method: 'patch'}
        return useAxios('/link', config, backendClient, useAxiosOptions)
    }

    const deleteLink = function(id: string, axiosRequestConfig: AxiosRequestConfig = {}, useAxiosOptions = defaultUseAxiosOptions) {
        const config = { ...axiosRequestConfig, method: 'delete'}
        return useAxios(`/link/${id}`, config, backendClient, useAxiosOptions)
    }

    return {
        getLink,
        getUserLinks,
        createLink,
        updateLink,
        deleteLink,
        getLinkByGuid
    }
}
